import { action } from '../actions';

export const FETCH_ALL_ROLES = 'FETCH_ALL_ROLES';
export const REQUEST_ALL_ROLES = 'REQUEST_ALL_ROLES';
export const SUCCESS_ALL_ROLES = 'SUCCESS_ALL_ROLES';
export const FAILURE_ALL_ROLES = 'FAILURE_ALL_ROLES';

export const fetchAllRoles = () => action(FETCH_ALL_ROLES);
export const requestAllRoles = () => action(REQUEST_ALL_ROLES);
export const requestAllRolesSuccess = (response: any) => action(SUCCESS_ALL_ROLES, { response });
export const requestAllRolesFailure = (error: any) => action(FAILURE_ALL_ROLES, { error });
